import { axInst } from "../../../Components/Login/Service";

export const pipeline_kpi = async (body) => {
  try {
    const res = await axInst.post("pipeline/cards", body);
    return {
      tat_c0_c3: res.data.tat_c0_c3,
      conversion_c0_c3: res.data.conversion_c0_c3,
      tat_c1a_c3: res.data.tat_c1a_c3,
      conversion_c1a_c3: res.data.conversion_c1a_c3,
    };
  } catch (error) {
    console.error(error);
  }
};
